import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Heading from 'uiKit/texts/Heading'
import { KnowledgeBaseSubTabMap } from 'tabs/nlp/constants'

import RadioButtonGroup from './RadioButtonGroup'
import WebsiteTab from './WebsiteTab'
import TextTab from './TextTab'
import FileTab from './FileTab'
import SettingsTab from './SettingsTab'

import { hasPermissionForFeature, getAIKnowledgePermissions } from '../../../../security'
import { BiMap } from '../../../../helpers/biMap'
import * as S from './KnowledgeBase.style'

const KnowledgeBase = props => {
  const {
    match: { params },
    activeBot,
  } = props

  const subTabFromPath = params.sourceType
  const sourceId = params.sourceId

  const tabPermissionMap = new BiMap(
    new Map([
      [KnowledgeBaseSubTabMap.WEBSITE, 'nlp-website'],
      [KnowledgeBaseSubTabMap.FILE, 'nlp-file'],
      [KnowledgeBaseSubTabMap.TEXT, 'nlp-text'],
      [KnowledgeBaseSubTabMap.SETTINGS, 'nlp-prompt'],
    ]),
  )

  const filteredTabs = getAIKnowledgePermissions(activeBot.id).map((permission: string) =>
    tabPermissionMap.get(permission),
  )
  const validatedSubTab = subTabFromPath in KnowledgeBaseSubTabMap && subTabFromPath

  const [activeTab, setActiveTab] = useState(validatedSubTab || filteredTabs[0])

  const hasPermissionForTab = tab =>
    hasPermissionForFeature(tabPermissionMap.get(tab), activeBot.id)

  const hasPermissionForUpdateCqc = hasPermissionForFeature('updateCqc', activeBot.id)

  return (
    <S.Container>
      <Heading>AI Knowledge</Heading>
      <S.SubHeaderWrap>
        <S.SubHeader>Connect different data sources for the chatbot knowledgebase</S.SubHeader>
      </S.SubHeaderWrap>
      <RadioButtonGroup value={activeTab} onChange={setActiveTab} allowedTabs={filteredTabs} />
      {activeTab === KnowledgeBaseSubTabMap.WEBSITE && hasPermissionForTab(KnowledgeBaseSubTabMap.WEBSITE) && (
        <WebsiteTab />
      )}
      {activeTab === KnowledgeBaseSubTabMap.FILE && hasPermissionForTab(KnowledgeBaseSubTabMap.FILE) && (
        <FileTab />
      )}
      {activeTab === KnowledgeBaseSubTabMap.TEXT && hasPermissionForTab(KnowledgeBaseSubTabMap.TEXT) && (
        <TextTab sourceId={sourceId} />
      )}
      {activeTab === KnowledgeBaseSubTabMap.SETTINGS && hasPermissionForTab(KnowledgeBaseSubTabMap.SETTINGS) && (
        <SettingsTab />
      )}
    </S.Container>
  )
}

const mapStateToProps = state => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(withRouter(KnowledgeBase))
